import {
  Rate
} from './rate.model';

import {
  RateCod
} from './rate-cod.model';

import {
  RateInsurance
} from './rate-insurance.model';

import {
  RateExtra
} from './rate-extra.model';

import {
  RateUnit
} from './rate-unit.model';

import {
  RatesZone
} from './rates-zone.model';

import {
  Service
} from './service.model';

import {
  ServiceExtra
} from './service-extra.model';

import {
  Surcharge
} from './surcharge.model';

import {
  Translation
} from './translation.model';

import {
  User
} from './user.jwt.model';

export class Pricelist {
  _id?: string;
  context?: string;
  countryCode: string;
  currencySymbol: string;
  currencyCode: string;
  partnerCode: string;
  isCod: boolean = true;
  isDraft: boolean = true;
  orderMin?: number;
  orderMax?: number;
  averageMonthlyConsignments?: number;
  internal?: string;
  ownerEmail: string;
  label: string = 'Draft';
  labelHuman?: string;
  priceMax: number;
  priceMaxCurrency: string;
  priceMaxCurrencySymbol: string;
  rateCurrency?: number;
  rates: Rate[] = [];
  ratesZones: RatesZone[] = [];
  ratesInfo: string = '';
  ratesInsurance: RateInsurance[] = [];
  rateExtra: RateExtra = new RateExtra();
  rateReturnExtra: RateExtra = new RateExtra();
  rateUnit: RateUnit = new RateUnit();
  rateUnitHasFranking: boolean = false;
  rateUnitFrankingType: string;
  ratesCod: RateCod[] = [];
  ratesCodInfo: string = '';
  ratesReturn: Rate[] = [];
  ratesReturnZones: RatesZone[] = [];
  ratesReturnInfo: string = '';
  rateReturnFee: number = 0;
  rateReturnHasCod: boolean = true;
  rateReturnHasPos: boolean = true;
  rateReturnType: string = 'free';
  regionCodes: string[] = [];
  services: Service[]|string[];
  serviceProtocolUrl?: string;
  servicesExtra: ServiceExtra[] = [];
  servicesExtraInfo: string;
  surcharges: Surcharge[] = [];
  surchargesInfo: string;
  translations: Translation[] = [];
  users: User[]|string[];
  validTimestampStart?: Date;
  validTimestampEnd?: Date;
  vatRate: number = 0.24;
  volumeFirst: boolean = true;
  volumeWeightFactor: number;
  weightMax: number;
  documentTemplate: string = 'Legacy';
  hasInsurance: boolean = false;
  insuranceInfo: string;
  insuranceMax: number;
  insuranceMaxCurrency: string;
  insuranceMaxCurrencySymbol: string;
  
  constructor(
    countryCode: string,
    currencyCode: string,
    currencySymbol: string,
    priceMax: number,
    priceMaxCurrency: string,
    insuranceMax: number,
    insuranceMaxCurrency: string,
    ownerEmail: string,
    services: Service[]
  ) {
    this.countryCode = countryCode;
    this.currencyCode = currencyCode;
    this.currencySymbol = currencySymbol;
    this.priceMax = priceMax;
    this.priceMaxCurrency = priceMaxCurrency;
    this.insuranceMax = insuranceMax;
    this.insuranceMaxCurrency = insuranceMaxCurrency;
    this.ownerEmail = ownerEmail;
    this.services = services;
  }
};
